import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EmailReceiptDialogComponent } from './email-receipt.dialog';
import { InvoicesService } from 'src/app/services/invoices.service';
import { InvoiceInterface } from '@contracts/interfaces/invoice.interface';

@Injectable({
  providedIn: 'root'
})
export class EmailReceiptDialogService {

    public confirmEvidence: boolean = false;

    constructor(
        public dialog: MatDialog,
        public invoiceService: InvoicesService) {}

    public open(invoice: InvoiceInterface, callback: any) {
        return this.invoiceService.get(invoice.number).subscribe((result) => {
            let dialog = this.dialog.open(EmailReceiptDialogComponent, {
                autoFocus: false,
                width: '950px',
                data: {
                    invoice
                }
            });

            dialog.afterClosed().subscribe(job => {
                callback(job);
            })
        });
    }
}
